module.exports = __webpack_public_path__ + "img/lcp-logo.b494d602.png";